/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { getCustomerDataResponse } from '@/auth/types';
import { CustomerModel } from '../models';
import { config } from '@/auth/api';
import { merge } from '@adobe-commerce/elsie/lib';

export const transformCustomerData = (
  response: getCustomerDataResponse
): CustomerModel => {
  const model = {
    email: response?.data?.customer?.email ?? '',
    firstName: response?.data?.customer?.firstname ?? '',
    lastName: response?.data?.customer?.lastname ?? '',
    groupUid: response?.data?.customer?.group?.uid ?? '',
  };

  // Extend the model merging custom transformer, if provided
  return merge(
    model, // default transformer
    config?.getConfig()?.models?.CustomerModel?.transformer?.(response.data) // custom transformer
  );
};
